module.exports = __webpack_public_path__ + "img/panda_express_2.b08af6f7.webp";